export default __webpack_public_path__ + "static/media/icon-google.75dbe9c9.webp";